import { gql } from '@apollo/client'

export const DEFAULT_QUERY = gql`
  query DefaultQuery {
    __typename
  }
`
